import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

/** Owner-issued password reset section. */
export default function DrawerPasswordReset({ userId }) {
  const [show, setShow] = useState(false);
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = async () => {
    if (pw.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setBusy(true);
    try {
      await api.post(`/owner/users/${userId}/reset-password`, { new_password: pw });
      toast.success("Password reset");
      setShow(false);
      setPw("");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="px-5 py-5 border-t-2" style={{ borderTopColor: "rgba(249,215,28,0.3)" }}>
      <div className="flex items-center gap-2 mb-3">
        <KeyRound className="w-4 h-4" style={{ color: "#F9D71C" }} strokeWidth={3} />
        <h3 className="font-heading text-lg">PASSWORD RESET</h3>
      </div>
      {!show ? (
        <button
          data-testid="show-pw-form"
          onClick={() => setShow(true)}
          className="w-full h-11 inline-flex items-center justify-center gap-2 border-2 text-xs font-bold uppercase tracking-wider hover:bg-safety-yellow hover:text-black transition-colors"
          style={{ borderColor: "#F9D71C" }}
        >
          <KeyRound className="w-3.5 h-3.5" strokeWidth={3} />
          Reset Password
        </button>
      ) : (
        <div className="space-y-3">
          <input
            data-testid="drawer-new-password"
            type="text"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="New password (min 6 chars)"
            autoComplete="off"
            className="w-full h-11 px-3 bg-white/5 border-2 text-white placeholder:text-white/40 font-mono"
            style={{ borderColor: "#F9D71C" }}
          />
          <div className="flex gap-2">
            <button
              data-testid="confirm-pw-reset"
              onClick={reset}
              disabled={busy || pw.length < 6}
              className="flex-1 h-11 bg-safety-yellow text-black border-2 border-safety-yellow font-bold uppercase tracking-wider text-xs hover:bg-safety-yellowHover disabled:opacity-60"
            >
              {busy ? "Saving…" : "Confirm Reset"}
            </button>
            <button
              onClick={() => { setShow(false); setPw(""); }}
              className="h-11 px-4 border-2 text-xs font-bold uppercase tracking-wider hover:bg-white/10"
              style={{ borderColor: "#F9D71C" }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
